import {useUpdateInfluencerFilterMutation} from "@/api/influencerApi";
import TimesIcon from "@/assets/colorable/times.svg?react";
import WarningIcon from "@/assets/colorable/warning.svg?react";
import Button from "@/components/Common/Button";
import Modal from "@/components/Common/Modal";
import {discardFilterChangesModalAtom, editFilterAtom} from "@/store/jotaiAtoms";
import {useAtom, useSetAtom} from "jotai";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const DiscardFilterChangesModal: FC = () => {
  const {t} = useTranslation(["influencer_list", "common"]);
  const [modalData, setModalData] = useAtom(discardFilterChangesModalAtom);
  const setEditFilter = useSetAtom(editFilterAtom);

  const {mutate: saveFilter, isPending} = useUpdateInfluencerFilterMutation({
    filterId: modalData?.filterId,
    onSuccess: () => {
      if (modalData) {
        modalData.action();
      }
      setEditFilter(null);
      setModalData(null);
    },
  });

  const handleClose = () => {
    if (!isPending) setModalData(null);
  };

  return (
    <Modal
      onClose={handleClose}
      shouldHideModalTitle
      backgroundClassName="w-[95vw] sm:w-135 md:w-135 max-h-none rounded-xl"
      className="gap-0 p-0"
      customBottomRow={
        <div className="border-neutral-grey-light-dark flex gap-2.5 border-t px-10 py-5">
          <Button
            buttonStyle="White"
            className="h-15 flex-1"
            isDisabled={isPending}
            onClick={() => {
              modalData?.action();
              setModalData(null);
            }}>
            {t("discard_changes")}
          </Button>
          <Button
            buttonStyle="Gradient"
            className="h-15 flex-1"
            isDisabled={!modalData?.filterName.trim()}
            isLoading={isPending}
            onClick={() =>
              modalData && saveFilter({filter_params: modalData.filterParams, name: modalData.filterName.trim()})
            }>
            {t("common:Save")}
          </Button>
        </div>
      }>
      <div className="bg-warning-light-yellow relative flex flex-col items-center gap-5 p-5">
        <button className="absolute top-5 right-5" onClick={handleClose}>
          <TimesIcon className="text-neutral-grey-light size-3.5" />
        </button>
        <div className="flex flex-col items-center gap-3">
          <div className="flex size-15 items-center justify-center rounded-full bg-white">
            <WarningIcon className="text-warning-dark-yellow size-7" />
          </div>
          <span className="text-neutral-black text-xl font-semibold">{t("discard_filter_changes_title")}</span>
        </div>
        <span className="text-neutral-black text-xs">{t("discard_filter_changes_description")}</span>
      </div>
    </Modal>
  );
};

export default DiscardFilterChangesModal;
